<div class="pt-0 mt-0">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">التقارير</h3>
      </div>
    </div>
  </div>
</div>
